const TRAIL_LENGTH = 25;
const PARTICLE_LIFETIME = 60;
const MAX_PARTICLES = 200;
const TRAIL_MAX_AGE = 40;

const PALETTE = [
  { r: 0, g: 123, b: 255 },
  { r: 0, g: 90, b: 210 },
  { r: 204, g: 255, b: 0 },
  { r: 0, g: 160, b: 255 },
  { r: 100, g: 230, b: 30 },
];

export function createFluidState() {
  return { mouse: { x: -100, y: -100 }, prevMouse: { x: -100, y: -100 }, trail: [], particles: [], colorIndex: 0 };
}

function nextColor(s) {
  s.colorIndex = (s.colorIndex + 1) % PALETTE.length;
  return PALETTE[s.colorIndex];
}

export function trackPointer(s, x, y) {
  s.prevMouse = { ...s.mouse };
  s.mouse = { x, y };
  const dx = x - s.prevMouse.x;
  const dy = y - s.prevMouse.y;
  const speed = Math.hypot(dx, dy);

  s.trail.push({ x, y, age: 0 });
  if (s.trail.length > TRAIL_LENGTH) s.trail.shift();

  const count = Math.min(Math.floor(speed / 3) + 1, 5);
  for (let i = 0; i < count && s.particles.length < MAX_PARTICLES; i++) {
    const c = nextColor(s);
    const angle = Math.atan2(dy, dx) + (Math.random() - 0.5) * 2;
    const vel = speed * 0.3 + Math.random() * 2;
    s.particles.push({
      x: x + (Math.random() - 0.5) * 10, y: y + (Math.random() - 0.5) * 10,
      vx: Math.cos(angle) * vel * 0.5, vy: Math.sin(angle) * vel * 0.5,
      life: PARTICLE_LIFETIME, maxLife: PARTICLE_LIFETIME, size: Math.random() * 4 + 2, ...c,
    });
  }
}

function drawTrail(ctx, s) {
  if (s.trail.length <= 2) return;
  const [a, , b] = PALETTE;
  for (let i = 1; i < s.trail.length; i++) {
    const t = s.trail[i];
    const prev = s.trail[i - 1];
    const p = i / s.trail.length;
    const mix = (k) => Math.round(a[k] + (b[k] - a[k]) * p);
    ctx.beginPath();
    ctx.moveTo(prev.x, prev.y);
    ctx.lineTo(t.x, t.y);
    ctx.strokeStyle = `rgba(${mix("r")},${mix("g")},${mix("b")},${p * 0.6})`;
    ctx.lineWidth = p * 8 + 1;
    ctx.lineCap = "round";
    ctx.stroke();
    t.age++;
  }
  s.trail = s.trail.filter((t) => t.age < TRAIL_MAX_AGE);
}

function drawGlow(ctx, x, y, radius, inner, outer) {
  const grad = ctx.createRadialGradient(x, y, 0, x, y, radius);
  grad.addColorStop(0, inner);
  grad.addColorStop(1, outer);
  ctx.fillStyle = grad;
  ctx.beginPath();
  ctx.arc(x, y, radius, 0, Math.PI * 2);
  ctx.fill();
}

function drawCursor(ctx, s) {
  const { x, y } = s.mouse;
  if (x <= 0 || y <= 0) return;
  drawGlow(ctx, x, y, 40, "rgba(0,123,255,0.25)", "rgba(0,123,255,0)");
  drawGlow(ctx, x, y, 6, "rgba(204,255,0,0.6)", "rgba(204,255,0,0)");
}

function drawParticles(ctx, s) {
  for (let i = s.particles.length - 1; i >= 0; i--) {
    const p = s.particles[i];
    p.x += p.vx; p.y += p.vy; p.vx *= 0.96; p.vy *= 0.96; p.life--;
    if (p.life <= 0) { s.particles.splice(i, 1); continue; }
    const ratio = p.life / p.maxLife;
    drawGlow(ctx, p.x, p.y, p.size * ratio * 2, `rgba(${p.r},${p.g},${p.b},${ratio * 0.7})`, `rgba(${p.r},${p.g},${p.b},0)`);
  }
}

export function renderFrame(ctx, s) {
  ctx.clearRect(0, 0, window.innerWidth, window.innerHeight);
  drawTrail(ctx, s);
  drawCursor(ctx, s);
  drawParticles(ctx, s);
}
